export enum LivingFacilitiesOption {
    UNKNOWN = 0,
    INTERNET = 1,
    WASHING_MACHINE = 2,
    FRIDGE = 3,
    DISHWASHER = 4,
    AIR_CONDITIONER = 5,
    TV = 6,
}
